import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import muiTheme from "../../design-system/muiTheme";

/** Theme values live in src/design-system/ (tokens.js → muiTheme.js). */
const MuiCustomTheme = ({ children }) => {
  return <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>;
};

export default MuiCustomTheme;
